<template>
	<footer class="footer relative">
		<div class="w-full pb-8 pt-5">
			<ContainedSection
				:has-padding="true"
				contained-class="md:px-5 xl:px-10"
			>
				<ul
					class="m-0 flex list-none items-center justify-center gap-x-2"
				>
					<li
						v-for="menuItem in menu"
						:key="menuItem.label"
						class="flex"
					>
						<CarbarLink
							class="flex items-center px-2 text-center"
							line-height="leading-tight"
							font-size="text-sm"
							:hover-color="whitelabel?.styles?.button?.hover"
							:href="menuItem.link"
							:target="menuItem.target"
							:underline="false"
						>
							{{ menuItem.label }}
						</CarbarLink>
					</li>
				</ul>
				<div
					v-if="!isAuthPage && partnerName === 'carsales'"
					class="w-full py-8"
				>
					<p class="text-center text-xsm text-gray-575">
						* carsales may receive a commission if you subscribe to
						carbar through this site
					</p>
				</div>
			</ContainedSection>
		</div>
	</footer>
</template>

<script setup>
import CarbarLink from '@/components/links/CarbarLink.vue'
import ContainedSection from '@/components/sections/ContainedSection.vue'

const { partnerName } = useGetPartnerName()
const { whitelabel } = useWhitelabelsStyles()

const route = useRoute()

const { isAuthPage } = useAuthPaths(route.path)

const menu = ref([
	{
		key: 'terms-and-conditions',
		label: 'Privacy policy',
		link: '/privacy-policy',
		target: '_blank',
		current: false,
	},
	{
		key: 'terms-and-conditions',
		label: 'Terms and conditions',
		link: '/terms-and-conditions',
		target: '_blank',
		current: false,
	},
])
</script>
